function addSceneEvents(scene) {
  document.body.addEventListener('click', (event) => {
    if (event.target.nodeName !== 'CANVAS') return;

    const canvasBox = event.target.getBoundingClientRect();

    if (canvasBox) {
      // Check for click on wall switch
      if (
        event.clientX < canvasBox.right &&
        event.clientX > canvasBox.right - 25 &&
        event.clientY > canvasBox.top + 25 &&
        event.clientY < canvasBox.bottom - 15
      ) {
        if (!scene.inputDisabled) scene.switchOff();
      }

      // Check for click on 3-way switch
      if (
        event.clientX > canvasBox.left &&
        event.clientX < canvasBox.left + 40 &&
        event.clientY > canvasBox.top + 29 &&
        event.clientY < canvasBox.bottom
      ) {
        //console.log('3 way switch click!');
        const { floorSwitchBox } = scene;

        if (floorSwitchBox.frame < 2) {
          floorSwitchBox.frame += 1;
        } else {
          floorSwitchBox.frame = 0;
        }

        let elActive = document.body.querySelector('.active');

        if (elActive) elActive.classList.remove('active', 'masonry');

        if (floorSwitchBox.frame === 0) elActive = document.body.querySelector('.game-media-theme-content');
        if (floorSwitchBox.frame === 1) elActive = document.body.querySelector('.half-rounded-theme-content');
        if (floorSwitchBox.frame === 2) elActive = document.body.querySelector('.half-rounded-theme-content');


        elActive.classList.add('active');

        if (floorSwitchBox.frame === 2) elActive.classList.add('masonry');
      }
    }
  });

  window.addEventListener('resize', resizeHandler);

  function resizeHandler() {
    scene.positionScene();

    // Try with some delay so orientation change resize has time to complete
    setTimeout(() => scene.positionScene(), 300);
  }
}

export default addSceneEvents;
